var _rect, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgFacebook = function SvgFacebook(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 7.5H20C18.6739 7.5 17.4021 8.02678 16.4645 8.96447C15.5268 9.90215 15 11.1739 15 12.5V15.5H12V19.5H15V27.5H19V19.5H22L23 15.5H19V12.5C19 12.2348 19.1054 11.9804 19.2929 11.7929C19.4804 11.6054 19.7348 11.5 20 11.5H23V7.5Z",
    stroke: "#FB8400",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFacebook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Facebook.319d1863.svg";
export { ForwardRef as ReactComponent };